import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, IonButtons, IonButton } from '@ionic/react';
import { useState, useEffect } from 'react';
import { addOutline, chevronBack } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { addDocumentTemplateListener } from '../firebase/documentTemplates';

const DocumentTemplatesListPage: React.FC = () => {
  const history = useHistory();
  const [documentTemplates, setDocumentTemplates] = useState([]);

  useEffect(() => {
    addDocumentTemplateListener((list: any) => {
      setDocumentTemplates(list);
    });
  }, []);


  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={history.goBack}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Szablony Dokumentów</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>


        {documentTemplates.map((t: any) => (
          <IonItem routerLink={"/app/settings/documenttemplates/"+t.id} key={t.id} >
            <IonLabel>{t.topic}</IonLabel>
          </IonItem>
        ))}

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => { history.push("/app/settings/documenttemplates/0")}}>
            <IonIcon icon={addOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default DocumentTemplatesListPage;
